<template>
  <v-app id="app" class="auth-layout">
    <myHeader />

    <v-content>
      <v-container fluid fill-height>
        <router-view />
      </v-container>

      <notificationBar />
    </v-content>
  </v-app>
</template>

<script>
import myHeader from "../../themes/partials/HeaderAuth.vue"
import notificationBar from "@/modules/notifications/partials/NotificationBar.vue"

export default {
  name: "my-login-layout",

  components: {
    myHeader,
    notificationBar
  }
}
</script>
